// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessconflict/v1/app_entitlement_monitor_binding.proto" (package "c1.api.accessconflict.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlementExpandMask } from "../../app/v1/app_entitlement";
/**
 * @generated from protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsRequest
 */
export interface SearchAppEntitlementMonitorBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string monitor_id = 3
     */
    monitorId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef refs = 6
     */
    refs: AppEntitlementMonitorBindingRef[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsResponse
 */
export interface SearchAppEntitlementMonitorBindingsResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingView list = 3
     */
    list: AppEntitlementMonitorBindingView[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsRequest
 */
export interface ListAppEntitlementMonitorBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string monitor_id = 3
     */
    monitorId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsResponse
 */
export interface ListAppEntitlementMonitorBindingsResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 3
     */
    list: AppEntitlementView[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.GetAppEntitlementMonitorBindingRequest
 */
export interface GetAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4
     */
    entitlementGroup: EntitlementGroup;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingRequest
 */
export interface DeleteAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4
     */
    entitlementGroup: EntitlementGroup;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingResponse
 */
export interface DeleteAppEntitlementMonitorBindingResponse {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.UpdateAppEntitlementMonitorBindingRequest
 */
export interface UpdateAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 2
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements_to_add = 3
     */
    entitlementsToAdd: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements_to_remove = 4
     */
    entitlementsToRemove: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.CreateAppEntitlementMonitorBindingRequest
 */
export interface CreateAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4
     */
    entitlementGroup: EntitlementGroup;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBinding
 */
export interface AppEntitlementMonitorBinding {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingView
 */
export interface AppEntitlementMonitorBindingView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef ref = 2
     */
    ref?: AppEntitlementMonitorBindingRef;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef
 */
export interface AppEntitlementMonitorBindingRef {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf enum c1.api.accessconflict.v1.EntitlementGroup
 */
export enum EntitlementGroup {
    /**
     * @generated from protobuf enum value: ENTITLEMENT_GROUP_UNSPECIFIED = 0;
     */
    ENTITLEMENT_GROUP_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ENTITLEMENT_GROUP_A = 1;
     */
    ENTITLEMENT_GROUP_A = 1,
    /**
     * @generated from protobuf enum value: ENTITLEMENT_GROUP_B = 2;
     */
    ENTITLEMENT_GROUP_B = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementMonitorBindingsRequest$Type extends MessageType<SearchAppEntitlementMonitorBindingsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementMonitorBindingRef }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementMonitorBindingsRequest>): SearchAppEntitlementMonitorBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.monitorId = "";
        message.entitlementGroup = 0;
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementMonitorBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementMonitorBindingsRequest): SearchAppEntitlementMonitorBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string monitor_id */ 3:
                    message.monitorId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 4:
                    message.entitlementGroup = reader.int32();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef refs */ 6:
                    message.refs.push(AppEntitlementMonitorBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementMonitorBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string monitor_id = 3; */
        if (message.monitorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.monitorId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4; */
        if (message.entitlementGroup !== 0)
            writer.tag(4, WireType.Varint).int32(message.entitlementGroup);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementMonitorBindingRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsRequest
 */
export const SearchAppEntitlementMonitorBindingsRequest = new SearchAppEntitlementMonitorBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementMonitorBindingsResponse$Type extends MessageType<SearchAppEntitlementMonitorBindingsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementMonitorBindingView }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementMonitorBindingsResponse>): SearchAppEntitlementMonitorBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        message.expanded = [];
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementMonitorBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementMonitorBindingsResponse): SearchAppEntitlementMonitorBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string next_page_token */ 1:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingView list */ 3:
                    message.list.push(AppEntitlementMonitorBindingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementMonitorBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string next_page_token = 1; */
        if (message.nextPageToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingView list = 3; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementMonitorBindingView.internalBinaryWrite(message.list[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsResponse
 */
export const SearchAppEntitlementMonitorBindingsResponse = new SearchAppEntitlementMonitorBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementMonitorBindingsRequest$Type extends MessageType<ListAppEntitlementMonitorBindingsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementMonitorBindingsRequest>): ListAppEntitlementMonitorBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.monitorId = "";
        message.entitlementGroup = 0;
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementMonitorBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementMonitorBindingsRequest): ListAppEntitlementMonitorBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string monitor_id */ 3:
                    message.monitorId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 4:
                    message.entitlementGroup = reader.int32();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementMonitorBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string monitor_id = 3; */
        if (message.monitorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.monitorId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4; */
        if (message.entitlementGroup !== 0)
            writer.tag(4, WireType.Varint).int32(message.entitlementGroup);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsRequest
 */
export const ListAppEntitlementMonitorBindingsRequest = new ListAppEntitlementMonitorBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementMonitorBindingsResponse$Type extends MessageType<ListAppEntitlementMonitorBindingsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementMonitorBindingsResponse>): ListAppEntitlementMonitorBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        message.expanded = [];
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementMonitorBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementMonitorBindingsResponse): ListAppEntitlementMonitorBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string next_page_token */ 1:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 3:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementMonitorBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string next_page_token = 1; */
        if (message.nextPageToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementView list = 3; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsResponse
 */
export const ListAppEntitlementMonitorBindingsResponse = new ListAppEntitlementMonitorBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementMonitorBindingRequest$Type extends MessageType<GetAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.GetAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementMonitorBindingRequest>): GetAppEntitlementMonitorBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.entitlementGroup = 0;
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementMonitorBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementMonitorBindingRequest): GetAppEntitlementMonitorBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 4:
                    message.entitlementGroup = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementMonitorBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4; */
        if (message.entitlementGroup !== 0)
            writer.tag(4, WireType.Varint).int32(message.entitlementGroup);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.GetAppEntitlementMonitorBindingRequest
 */
export const GetAppEntitlementMonitorBindingRequest = new GetAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementMonitorBindingRequest$Type extends MessageType<DeleteAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] }
        ]);
    }
    create(value?: PartialMessage<DeleteAppEntitlementMonitorBindingRequest>): DeleteAppEntitlementMonitorBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.entitlementGroup = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementMonitorBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementMonitorBindingRequest): DeleteAppEntitlementMonitorBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 4:
                    message.entitlementGroup = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementMonitorBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4; */
        if (message.entitlementGroup !== 0)
            writer.tag(4, WireType.Varint).int32(message.entitlementGroup);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingRequest
 */
export const DeleteAppEntitlementMonitorBindingRequest = new DeleteAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementMonitorBindingResponse$Type extends MessageType<DeleteAppEntitlementMonitorBindingResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingResponse", []);
    }
    create(value?: PartialMessage<DeleteAppEntitlementMonitorBindingResponse>): DeleteAppEntitlementMonitorBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementMonitorBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementMonitorBindingResponse): DeleteAppEntitlementMonitorBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementMonitorBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingResponse
 */
export const DeleteAppEntitlementMonitorBindingResponse = new DeleteAppEntitlementMonitorBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppEntitlementMonitorBindingRequest$Type extends MessageType<UpdateAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.UpdateAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 3, name: "entitlements_to_add", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 4, name: "entitlements_to_remove", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<UpdateAppEntitlementMonitorBindingRequest>): UpdateAppEntitlementMonitorBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.entitlementGroup = 0;
        message.entitlementsToAdd = [];
        message.entitlementsToRemove = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateAppEntitlementMonitorBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppEntitlementMonitorBindingRequest): UpdateAppEntitlementMonitorBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 2:
                    message.entitlementGroup = reader.int32();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlements_to_add */ 3:
                    message.entitlementsToAdd.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlements_to_remove */ 4:
                    message.entitlementsToRemove.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppEntitlementMonitorBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 2; */
        if (message.entitlementGroup !== 0)
            writer.tag(2, WireType.Varint).int32(message.entitlementGroup);
        /* repeated c1.api.app.v1.AppEntitlementRef entitlements_to_add = 3; */
        for (let i = 0; i < message.entitlementsToAdd.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementsToAdd[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef entitlements_to_remove = 4; */
        for (let i = 0; i < message.entitlementsToRemove.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementsToRemove[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.UpdateAppEntitlementMonitorBindingRequest
 */
export const UpdateAppEntitlementMonitorBindingRequest = new UpdateAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementMonitorBindingRequest$Type extends MessageType<CreateAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.CreateAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] }
        ]);
    }
    create(value?: PartialMessage<CreateAppEntitlementMonitorBindingRequest>): CreateAppEntitlementMonitorBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.entitlementGroup = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateAppEntitlementMonitorBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppEntitlementMonitorBindingRequest): CreateAppEntitlementMonitorBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 4:
                    message.entitlementGroup = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppEntitlementMonitorBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4; */
        if (message.entitlementGroup !== 0)
            writer.tag(4, WireType.Varint).int32(message.entitlementGroup);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.CreateAppEntitlementMonitorBindingRequest
 */
export const CreateAppEntitlementMonitorBindingRequest = new CreateAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementMonitorBinding$Type extends MessageType<AppEntitlementMonitorBinding> {
    constructor() {
        super("c1.api.accessconflict.v1.AppEntitlementMonitorBinding", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementMonitorBinding>): AppEntitlementMonitorBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.entitlementGroup = 0;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementMonitorBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementMonitorBinding): AppEntitlementMonitorBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group */ 4:
                    message.entitlementGroup = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementMonitorBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4; */
        if (message.entitlementGroup !== 0)
            writer.tag(4, WireType.Varint).int32(message.entitlementGroup);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBinding
 */
export const AppEntitlementMonitorBinding = new AppEntitlementMonitorBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementMonitorBindingView$Type extends MessageType<AppEntitlementMonitorBindingView> {
    constructor() {
        super("c1.api.accessconflict.v1.AppEntitlementMonitorBindingView", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "ref", kind: "message", T: () => AppEntitlementMonitorBindingRef }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementMonitorBindingView>): AppEntitlementMonitorBindingView {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementMonitorBindingView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementMonitorBindingView): AppEntitlementMonitorBindingView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef ref */ 2:
                    message.ref = AppEntitlementMonitorBindingRef.internalBinaryRead(reader, reader.uint32(), options, message.ref);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementMonitorBindingView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef ref = 2; */
        if (message.ref)
            AppEntitlementMonitorBindingRef.internalBinaryWrite(message.ref, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingView
 */
export const AppEntitlementMonitorBindingView = new AppEntitlementMonitorBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementMonitorBindingRef$Type extends MessageType<AppEntitlementMonitorBindingRef> {
    constructor() {
        super("c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementMonitorBindingRef>): AppEntitlementMonitorBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementMonitorBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementMonitorBindingRef): AppEntitlementMonitorBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementMonitorBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef
 */
export const AppEntitlementMonitorBindingRef = new AppEntitlementMonitorBindingRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AppEntitlementMonitorBindingService
 */
export const AppEntitlementMonitorBindingService = new ServiceType("c1.api.accessconflict.v1.AppEntitlementMonitorBindingService", [
    { name: "ListAppEntitlementMonitorBindings", options: { "authz.method": { role: "VIEWER" } }, I: ListAppEntitlementMonitorBindingsRequest, O: ListAppEntitlementMonitorBindingsResponse },
    { name: "GetAppEntitlementMonitorBinding", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/appentitlementmonitorbinding/get", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Entitlement_Monitor_Binding" }], group: "App Entitlement Monitor Binding" }] } }, I: GetAppEntitlementMonitorBindingRequest, O: AppEntitlementMonitorBinding },
    { name: "UpdateAppEntitlementMonitorBinding", options: { "authz.method": { role: "EDITOR" } }, I: UpdateAppEntitlementMonitorBindingRequest, O: Empty },
    { name: "DeleteAppEntitlementMonitorBinding", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/appentitlementmonitorbinding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Entitlement_Monitor_Binding" }], group: "App Entitlement Monitor Binding" }] } }, I: DeleteAppEntitlementMonitorBindingRequest, O: DeleteAppEntitlementMonitorBindingResponse },
    { name: "CreateAppEntitlementMonitorBinding", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/appentitlementmonitorbinding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Entitlement_Monitor_Binding" }], group: "App Entitlement Monitor Binding" }] } }, I: CreateAppEntitlementMonitorBindingRequest, O: AppEntitlementMonitorBinding }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AppEntitlementMonitorBindingSearchService
 */
export const AppEntitlementMonitorBindingSearchService = new ServiceType("c1.api.accessconflict.v1.AppEntitlementMonitorBindingSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementMonitorBindingsRequest, O: SearchAppEntitlementMonitorBindingsResponse }
]);
